export default __webpack_public_path__ + "static/media/p20-tip-box.3f2ebabf.svg";